import React from 'react';
import { IconProps } from '../types';

export const TwitterIcon = (props: IconProps) => {
  const { size = 28, color = '#FFFFFF', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      style={style}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path
        d='M13.039 13L19.2164 21.2734L13 28H14.3991L19.8415 22.1108L24.2389 28H29L22.475 19.2612L28.2612 13H26.8621L21.8499 18.4239L17.8001 13H13.039ZM15.0964 14.0323H17.2837L26.9422 26.9676H24.755L15.0964 14.0323Z'
        fill={color}
      />
    </svg>
  );
};
